import { useEffect, useState } from 'react';

export const RECOVERY_AUTHENTICATING_DELAY_MS = 500;
export const RECOVERY_STALLED_DELAY_MS = 8_000;

export type RecoveryUxPhase = 'silent' | 'authenticating' | 'stalled';

export const resolveRecoveryUxPhase = (active: boolean, elapsedMs: number): RecoveryUxPhase => {
  if (!active) return 'silent';
  if (elapsedMs < RECOVERY_AUTHENTICATING_DELAY_MS) return 'silent';
  if (elapsedMs < RECOVERY_STALLED_DELAY_MS) return 'authenticating';
  return 'stalled';
};

export const useRecoveryUxPhase = (active: boolean): RecoveryUxPhase => {
  const [phase, setPhase] = useState<RecoveryUxPhase>('silent');

  useEffect(() => {
    if (!active) {
      setPhase('silent');
      return;
    }
    setPhase('silent');
    const startedAt = Date.now();
    const authenticatingTimer = window.setTimeout(() => {
      setPhase(resolveRecoveryUxPhase(true, Date.now() - startedAt));
    }, RECOVERY_AUTHENTICATING_DELAY_MS);
    const stalledTimer = window.setTimeout(() => {
      setPhase(resolveRecoveryUxPhase(true, Date.now() - startedAt));
    }, RECOVERY_STALLED_DELAY_MS);
    return () => {
      window.clearTimeout(authenticatingTimer);
      window.clearTimeout(stalledTimer);
    };
  }, [active]);

  return phase;
};
